<template>
  <sp-alert
    v-if="showAlert"
    :type="model.type"
    class="insurance-alert-tiny-layout"
    variant="text"
    :data-testid="TestId.insurance.networkBadge"
  >
    <CompactLayoutContent :model="model" :accepted-label="acceptedLabel" />
  </sp-alert>
</template>

<script setup>
import { computed } from "vue";
import { TestId } from "#/test-ids";
import CompactLayoutContent from "./CompactLayoutContent.ce.vue";

const props = defineProps({
  model: {
    type: Object,
    required: true,
  },
  acceptedLabel: {
    type: String,
    default: "Accepts Your Insurance",
  },
});

const showAlert = computed(() => !props.model.isSelfPay && !props.model.isUndefined);
</script>

<style lang="scss" scoped>
.insurance-alert-tiny-layout {
  --alert-prepend-icon-size: 1em;
  --alert-prepend-icon-font-size: 1.3em;
  --alert-display: inline-grid;
  --alert-append-icon-fill: var(--sp-sys-color-link);
  --alert-prepend-icon-offset: 0;
  --alert-column-gap: var(--sp-comp-insurance-app-tiny-column-gap, 0.25rem);
  --alert-append-column-gap: 0.25rem;

  display: flex;
  position: relative;
  align-items: flex-start;
  min-height: var(--sp-ref-spacing-12);
}
</style>
